import { Component, ElementRef, forwardRef, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DwOrmDataServiceToken, DwOrmDataService, DwControlBaseComponent } from '@devwareapps/devware-cap';
import { AppMetaData, StandardColorSetEntity } from '../../../../meta-data/app-meta-data.service';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'dw-color-set-picker',
  templateUrl: './dw-color-set-picker.component.html',
  styleUrls: ['./dw-color-set-picker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DwColorSetPickerComponent),
    multi: true,
}]
})
export class DwColorSetPickerComponent extends DwControlBaseComponent implements OnChanges, OnInit {
  @Input() previewType: 'top-navigation' | 'sidebar' = 'top-navigation';

  colorSets: StandardColorSetEntity[];
  currentColor: StandardColorSetEntity;
  isOpen = false;

  constructor(
    private schoolRepositoryService: SchoolRepositoryService,
    private elementRef: ElementRef<HTMLElement>
  ) {
    super();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    
  }

  ngOnInit(): void {
    this.getColorSets();

    this.setupCurrentColor();
  }

  translateTo(value: any) {
    
    this.setupCurrentColor();

    return super.translateTo(value);
  }

  translateFrom(value: any) {
    this.setupCurrentColor(); 

    return super.translateFrom(value);
  }

  private setupCurrentColor() {
    this.currentColor = this.colorSets?.find(c => c.StandardColorSetId == this.value);
  }

  toggleDropdown(): void {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  selectColorSet(colorSet: StandardColorSetEntity): void {
    this.setTranslatedValue(colorSet?.StandardColorSetId);
    this.currentColor = colorSet;
    this.isOpen = false;
  }

  onTriggerKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleDropdown();
    } else if (event.key === 'Escape') {
      this.isOpen = false;
    }
  }

  trackByColorSetId(index: number, colorSet: StandardColorSetEntity): number | string {
    return colorSet?.StandardColorSetId == null ? 'default' : colorSet.StandardColorSetId;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as Node;

    if (this.isOpen && target && !this.elementRef.nativeElement.contains(target)) {
      this.isOpen = false;
    }
  }

  getColorSets() {

    this.schoolRepositoryService.getColorSets()
      .subscribe(colorSets => {
        this.colorSets = [{
          ColorSetName: 'Default',
          StandardColorSetId: null
        } as any,...colorSets];

        this.setupCurrentColor();
      });
  }

}
